export class MaterialIcon extends HTMLElement {
    // Define which attributes to watch for changes
    static get observedAttributes() {
        return ['icon', 'size', 'color'];
    }

    constructor(icon?: string, size?: string, color?: string, id?: string) {
        super();
        // Set initial properties if provided during construction
        if (icon) this.setAttribute('icon', icon);
        if (size) this.setAttribute('size', size);
        if (color) this.setAttribute('color', color);
        this.id = id || `material-icon-${Math.random().toString(36).substr(2, 9)}`; // Generate a unique ID if not provided
    }

    // connectedCallback runs when the element is added to the DOM
    connectedCallback() {
        this.classList.add('material-icons');
        this.render(); // Perform an initial render
    }

    // attributeChangedCallback runs whenever an observed attribute changes
    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (oldValue !== newValue) {
            this.render();
        }
    }

    // A central render method to update the element's appearance
    private render() {
        // Get current values from attributes, with defaults
        const icon = this.getAttribute('icon') || 'error';
        const size = this.getAttribute('size') || '24px';
        const color = this.getAttribute('color');

        // Update the icon and style
        this.textContent = icon;
        this.style.fontSize = size;

        if (color) {
            this.style.color = color;
        } else {
            this.style.removeProperty('color');
        }
    }

    // --- Property getters and setters for easier programmatic use ---
    get icon(): string {
        return this.getAttribute('icon') || 'error';
    }
    set icon(value: string) {
        this.setAttribute('icon', value);
    }

    get size(): string {
        return this.getAttribute('size') || '24px';
    }
    set size(value: string) {
        this.setAttribute('size', value);
    }

    get color(): string | null {
        return this.getAttribute('color');
    }
    set color(value: string | null) {
        if (value) {
            this.setAttribute('color', value);
        } else {
            this.removeAttribute('color');
        }
    }

    // --- Your static methods and define() remain unchanged ---
    static define() {
        if (!customElements.get('material-icon')) {
            customElements.define('material-icon', MaterialIcon);
        }
    }
    // (EDIT, FILE_DOWNLOAD, etc. static getters remain the same)
    static get EDIT() { return new MaterialIcon('edit'); }
    static get FILE_DOWNLOAD() { return new MaterialIcon('file_download'); }
    static get REFRESH() { return new MaterialIcon('refresh'); }
    static get ADD() { return new MaterialIcon('add'); }
    static get FILE_UPLOAD() { return new MaterialIcon('file_upload'); }
    static get UNDO() { return new MaterialIcon('undo'); }
    static get SAVINGS() { return new MaterialIcon('savings'); }
    static get QR_CODE() { return new MaterialIcon('qr_code'); }
    static get PLAYLIST_ADD() { return new MaterialIcon('playlist_add'); }
    static get GROUP_ADD() { return new MaterialIcon('group_add'); }
}

// Register the custom element
MaterialIcon.define();